import { DictationPhase } from '../enums/dictation-phase.enum.js';
/**
 * The function title recorded with every activation. Fixed in the UI-prototype
 * decision (TM-9575): the dialog does not ask for it, the Office-ADMIN's
 * self-declaration of authority stands in for it.
 */
export const AI_DOCUMENTATION_ACTIVATION_FUNCTION_TITLE = 'Geschäftsführung';
/** Hard cap of one dictation (charting decision, TM-9575 recorder). */
export const MAX_DICTATION_SECONDS = 600;
/** `POST /dictations` upload limit (Spec § 9); a 10-minute Opus/AAC recording is well below it. */
export const DICTATION_MAX_UPLOAD_BYTES = 25 * 1024 * 1024;
/**
 * Mime allowlist of the upload (Spec § 9). Browsers hand the blob type over
 * with parameters (`audio/webm;codecs=opus`); the check compares the base type.
 */
export const DICTATION_AUDIO_MIME_TYPES = [
    'audio/webm',
    'audio/mp4',
    'audio/ogg',
    'audio/aac',
    'audio/x-m4a',
];
/** Extension of `source.{ext}` in the dictation bucket (Spec § 5), by base mime type. */
export const DICTATION_SOURCE_EXTENSIONS = {
    'audio/webm': 'webm',
    'audio/mp4': 'mp4',
    'audio/ogg': 'ogg',
    'audio/aac': 'aac',
    'audio/x-m4a': 'm4a',
};
/** `audio/webm;codecs=opus` → `audio/webm`. */
export const toBaseMimeType = (mimeType) => mimeType.split(';')[0].trim().toLowerCase();
export const isDictationAudioMimeType = (mimeType) => DICTATION_AUDIO_MIME_TYPES.includes(toBaseMimeType(mimeType));
/** Phases during which the overview keeps polling (Spec § 9). */
export const DICTATION_ACTIVE_PHASES = [
    DictationPhase.UPLOADED,
    DictationPhase.NORMALIZING,
    DictationPhase.TRANSCRIBING,
    DictationPhase.DRAFTING,
];
export const DICTATION_OVERVIEW_POLL_INTERVAL_MS = 2_000;
//# sourceMappingURL=ai-documentation.const.js.map